/** Absolute streams over week_end_date (Luminate expand-row chart). */
export default function StreamsHistoryChart({ series, height = 180 }) {
  const points = (series || []).filter((p) => p?.date != null)
  if (points.length < 2) {
    return (
      <div
        className="flex items-center justify-center rounded-lg border border-dashed border-gray-200 bg-gray-50 text-sm text-gray-400"
        style={{ height }}
      >
        Not enough history for chart
      </div>
    )
  }

  const w = 640
  const h = height
  const pad = { t: 14, r: 14, b: 32, l: 56 }
  const innerW = w - pad.l - pad.r
  const innerH = h - pad.t - pad.b
  const values = points.map((p) => Number(p.streams) || 0)
  const dataMin = Math.min(...values)
  const dataMax = Math.max(...values)
  const yMin = dataMin >= 0 ? 0 : dataMin
  const yMax = dataMax === yMin ? yMin + 1 : dataMax
  const ySpan = yMax - yMin || 1

  const xAt = (i) => pad.l + (i / Math.max(points.length - 1, 1)) * innerW
  const yAt = (v) => pad.t + ((yMax - v) / ySpan) * innerH

  const linePath = points
    .map((p, i) => `${i === 0 ? 'M' : 'L'} ${xAt(i).toFixed(2)} ${yAt(Number(p.streams) || 0).toFixed(2)}`)
    .join(' ')

  const tickCount = 4
  const ticks = Array.from({ length: tickCount + 1 }, (_, i) => yMin + (ySpan * i) / tickCount)

  function formatStreams(n) {
    const v = Number(n) || 0
    if (Math.abs(v) >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`
    if (Math.abs(v) >= 1_000) return `${(v / 1_000).toFixed(1)}K`
    return String(Math.round(v))
  }

  const labelIndexes = (() => {
    const n = points.length
    if (n <= 6) return [...Array(n).keys()]
    const out = new Set([0, n - 1])
    for (let i = 1; i < 5; i += 1) {
      out.add(Math.round((i / 5) * (n - 1)))
    }
    return [...out].sort((a, b) => a - b)
  })()

  return (
    <div className="relative overflow-hidden rounded-lg border border-gray-200 bg-white">
      <svg
        viewBox={`0 0 ${w} ${h}`}
        className="h-auto w-full touch-pan-y"
        role="img"
        aria-label="Weekly streams history line chart"
      >
        {ticks.map((tick) => {
          const y = yAt(tick)
          return (
            <g key={`y-${tick}`}>
              <line
                x1={pad.l}
                x2={w - pad.r}
                y1={y}
                y2={y}
                stroke="#e5e7eb"
                strokeWidth="1"
              />
              <text
                x={pad.l - 8}
                y={y + 3}
                textAnchor="end"
                className="fill-gray-400"
                style={{ fontSize: 10 }}
              >
                {formatStreams(tick)}
              </text>
            </g>
          )
        })}
        <path d={linePath} fill="none" stroke="#2563eb" strokeWidth="2" strokeLinejoin="round" />
        {points.map((p, i) => (
          <circle
            key={`${p.date}-${i}`}
            cx={xAt(i)}
            cy={yAt(Number(p.streams) || 0)}
            r="2.5"
            fill="#2563eb"
          />
        ))}
        {labelIndexes.map((i) => (
          <text
            key={`x-${i}`}
            x={xAt(i)}
            y={h - 8}
            textAnchor="middle"
            className="fill-gray-400"
            style={{ fontSize: 9 }}
          >
            {String(points[i].date).slice(0, 10)}
          </text>
        ))}
      </svg>
    </div>
  )
}
